import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import moment from 'moment';

// coponent
import { USER_KEY } from '../../../const';
import CustomButton from '../../../components/CustomButton';
import { successUpdateSwal } from '../../../helper/sweetalert';
import AnimationLoading from '../../../components/Animationloading';
import { numberFormat } from '../../../helper';

// apollo
import { useLazyQuery, useMutation } from '@apollo/client';
import { UPDATE_EXCHANGERATE } from '../../../apollo/exchangeRate/Mutation';
import { GET_EXCHANGRATE } from '../../../apollo/exchangeRate/Query';

// icon
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Spinner, Table } from 'react-bootstrap';

function ExchangeRate() {
    const history = useHistory()
    const shop = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    const [ExchangeRate, setExchangeRate] = useState()
    const [isEdit, setIsEdit] = useState(false);
    const [editIndex, setEditIndex] = useState();
    const [editData, setEditData] = useState({});

    // ======== Query And Mutation ==========

    const [LoadExchangeRate, { data: GetExchangeRate, loading }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "cache-and-network" });
    const [updateExchangerate, { loading: loadingUpdate }] = useMutation(UPDATE_EXCHANGERATE)

    // ======== useEffect ==========

    useEffect(() => {
        _fetchExchangeRate();
    }, []);

    useEffect(() => {
        if (GetExchangeRate) {
            console.log("GetExchangeRate data:", GetExchangeRate);
            setExchangeRate([{
                id: GetExchangeRate?.exchangeRate?.id,
                currency: 'ບາດ',
                exchangeRate: GetExchangeRate?.exchangeRate?.baht
            }, {
                id: GetExchangeRate?.exchangeRate?.id,
                currency: 'ໂດລາ',
                exchangeRate: GetExchangeRate?.exchangeRate?.usd
            }]);
        }
    }, [GetExchangeRate]);

    // ======== Fuction ==========

    const _fetchExchangeRate = async () => {
        await LoadExchangeRate({
            variables: {
                exchangeRateWhere2: {
                    shop: shop,
                },
            },
        });
    }


    // ========== update ExchangeRate ==========
    const _updateExchangerate = async () => {
        // console.log(editData?.exchangeRate)
        try {
            // TODO: Check currency to update
            let _newExchangeRate;
            if (editData?.currency === 'ບາດ') _newExchangeRate = { baht: parseFloat(editData?.exchangeRate) }

            else _newExchangeRate = { usd: parseFloat(editData?.exchangeRate) }
            // console.log({ _newExchangeRate })
            if (loadingUpdate) return;
            await updateExchangerate({
                variables: {
                    where: {
                        id: editData?.id
                    },
                    data: _newExchangeRate
                }
            });

            setIsEdit(false);
            setEditIndex();
            setEditData({});
            successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
            _fetchExchangeRate()
        } catch (err) {
            // errorSwal('ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ')
            console.log("error creating todo:", err);
        }
    };


    // ================ Edit in box ========
    const onEditData = async (data, index) => {
        setIsEdit(true);
        setEditIndex(index);
        setEditData(data);
    };

    const onCancelEditData = async () => {
        setIsEdit(false);
        setEditIndex();
        setEditData({});
    };


    return (
        <React.Fragment>

            <div style={{
                paddingLeft: "15px",
                paddingRight: "15px"
            }}>
                <div style={{
                    backgroundColor: "#FFFFFF",
                    padding: '20px',
                    height: '100vh'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        color: "#3C169B"
                    }}>
                        <span style={{ fontSize: '24px', color: '#6B7280' }}>
                            <ArrowBackIcon sx={{ fontSize: "30px", cursor: "pointer" }} onClick={() => history.goBack()} />
                            &emsp;
                            ຕັ້ງຄ່າເລດເງີນ
                        </span>
                        <span>
                            {/* <CustomButton width="165px" height="46px" title="ເພີ່ມປະເພດ" icon={<AddBoxOutlinedIcon />} borderRadius="8px" /> */}
                        </span>
                    </div>

                    {/* table */}
                    {/* {(loading && !GetExchangeRate) && <AnimationLoading />} */}
                    <Table style={{
                        marginTop: "20px",
                        borderCollapse: "collapse",
                        width: "100% ",
                    }}>
                        <thead style={{
                            background: "#1F3A60",
                            borderRadius: " 8px 8px 0px 0px",
                            color: "#FFFFFF"
                        }}>
                            <tr>
                                <th>ລ/ດ</th>
                                <th>ສະກຸນເງີນ</th>
                                <th>ອັດຕາແລກປ່ຽນ</th>
                                <th>ວັນທີເດືອນປີ</th>
                                <th>ຈັດການ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ExchangeRate?.map((ex, index) => {
                                    return (
                                        <tr key={ex + index}>
                                            <td style={{ paddingTop: '1rem' }}>{index + 1}</td>
                                            <td style={{ paddingTop: '1rem' }}>
                                                {ex?.currency === "ບາດ" ?
                                                    <img src='../../../../../assets/image/thai.png' width={50} /> :
                                                    <img src='../../../../../assets/image/usd.png' width={50} />}
                                                &ensp;
                                                {ex?.currency}
                                            </td>
                                            <td style={{ paddingTop: '1rem' }}>

                                                {isEdit == true && editIndex === index ? (
                                                    <Form.Control
                                                        type="number"
                                                        name="baht"
                                                        onChange={(e) => {
                                                            let _data = editData;
                                                            _data = {
                                                                ...editData,
                                                                exchangeRate: e?.target?.value,
                                                            };
                                                            setEditData(_data);
                                                        }}
                                                        value={editData?.exchangeRate}
                                                        placeholder="ຈຳນວນເງິນ..."
                                                        style={{
                                                            border: editData.exchangeRate ? "" : "solid 1px red",
                                                            width: 'auto'
                                                        }}
                                                    />
                                                ) : (
                                                    <div>
                                                        {numberFormat(ex?.exchangeRate)}
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ paddingTop: '1rem' }}> {moment(ExchangeRate?.createdAt).format('DD/MM/YYYY')}</td>

                                            {isEdit == true && editIndex === index ? (
                                                <td style={{ width: "30%" }}>
                                                    <div style={{ display: "flex" }}>
                                                        <CustomButton
                                                            width="149px"
                                                            height="42px"
                                                            borderRadius="8px"
                                                            color="#3058A6"
                                                            background="#F1F1F1"
                                                            title="ຍົກເລີກ"
                                                            onClick={() => onCancelEditData()}
                                                        />
                                                        &ensp;
                                                        <CustomButton
                                                            width="149px"
                                                            height="42px"
                                                            borderRadius="8px"
                                                            title={loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                                                            onClick={() => _updateExchangerate()}
                                                        />
                                                    </div>
                                                </td>
                                            ) : (
                                                <td style={{ width: "30%" }}>

                                                    <CustomButton
                                                        width="149px"
                                                        height="42px"
                                                        borderRadius="8px"
                                                        textalign="center"
                                                        border="1px solid #3C169B"
                                                        title="ເເກ້ໄຂ"
                                                        color="#3C169B"
                                                        background="#F7F7F7"
                                                        icon={<MdOutlineBorderColor style={{ color: "#3C169B", fontSize: '20px' }} />}
                                                        onClick={() => onEditData(ex, index)}
                                                    />


                                                </td>
                                            )}

                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </Table>

                    {/* end table */}
                </div>
            </div>

        </React.Fragment>
    )
}

export default ExchangeRate